var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Summering_ej_obligatorisk25px25px';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Summering_ej_obligatorisk25px25px';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };